// extracted by mini-css-extract-plugin
module.exports = {"nl__inputs":"newsletter_nl__inputs__jf4n4","nl__form":"newsletter_nl__form__nOEAM","nl__feedback":"newsletter_nl__feedback__JLcIV"};